<template>
  <div class="comp-get-vip-dialog" v-if="getVipDialogVisible">
    <div class="get-vip-body">
      <div class="f24 pt30"><b>免费领取至尊VIP</b></div>
      <div class="pt30"><a href="javascript:" class="btn btn-lg btn-danger" v-before:login="{handler: bindGetVip}">立即领取</a></div>
      <p class="text-second mt30">点击领取至尊VIP，有效期至2020年6月9日（限领一次）</p>
      <div class="mt20"><a href="javascript:" class="btn" @click="setGetVipDialogVisible(false)">关闭窗口</a></div>
    </div>
  </div>
</template>

<script>
  /**
   * @author yueheqin
   * @date 2018/12/18
   * @project kaoshizhongxin-pc
   * @desc 登录弹框组件
   */
  import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
  import { loginCBMixin } from '../mixins/login-callback'
  import { getVipApi } from '../api/vip'

  export default {
    name: 'comp-get-vip-dialog',
    components: {
    },
    mixins: [loginCBMixin],
    data () {
      return {
        loginLoading: false
      }
    },
    computed: {
      ...mapState('common', ['getVipDialogVisible', 'loginSuccessHandle']),
      ...mapGetters('common', ['currentSubject', 'subjectList']),
      ...mapState('user', ['canGetVip']),
      ...mapGetters('user', ['isVip'])
    },
    created () {
    },
    methods: {
      ...mapMutations('common', ['setGetVipDialogVisible']),
      ...mapActions('user', ['getUserInfo']),
      bindGetVip () {
        let vm = this
        if (vm.canGetVip == 0) {
          vm.$message('您已经是至尊VIP用户')
          vm.setGetVipDialogVisible(false)
        } else {
          getVipApi().then(res => {
            vm.$message(res.data)
            vm.setGetVipDialogVisible(false)
            vm.getUserInfo()
          })
        }
      }
    }
  }
</script>

<style lang="less">
  .comp-get-vip-dialog {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0,0,0,.6);
    position: fixed;
    right:0;
    left:0;
    top:0;
    bottom:0;
    z-index: 2000;
    .get-vip-body {
      text-align: center;
      height:300px;
      width:400px;
      padding:30px;
      background-color: #fff;
      border:1px solid #ddd;
      border-radius: 3px;
    }
  }
</style>
